module.exports = __webpack_public_path__ + "media/images/flags/64/Philippines-44ffd1389d2073e77479399bf28f2e2a.png";